import i18n from '@configs/i18n';

import { getLanguage } from '@utils';

export const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
};

export const dateTimeFormat = (date: Date) => {
  const locale = getLanguage();
  return Intl.DateTimeFormat(locale ?? i18n.language, DATE_TIME_OPTIONS).format(
    date
  );
};

export const formatDate = (date: Date, options: Intl.DateTimeFormatOptions) => {
  const locale = getLanguage();
  return Intl.DateTimeFormat(locale ?? i18n.language, options).format(date);
};

export const formatDateUTC = (
  date: Date,
  options: Intl.DateTimeFormatOptions
) => {
  const locale = getLanguage();
  const timeZone = 'GMT';
  return Intl.DateTimeFormat(locale ?? i18n.language, {
    ...options,
    timeZone,
  }).format(date);
};

export const formatDateWithTimezone = (date: Date, timeZone: string) => {
  const locale = getLanguage();
  return Intl.DateTimeFormat(locale ?? i18n.language, {
    ...DATE_TIME_OPTIONS,
    timeZone,
  }).format(date);
};
